import styles from "./Instructions.module.css";
import { ButtonFooter } from "../../../../common/ButtonFooter";
import { Button } from "../../../../common/Button";

interface OptionsProps {
  instructions?: string;
  onPaid: () => void;
  isLoading?: boolean;
  isPaymentPending?: boolean;

}

export const Instructions = ({
  instructions,
  onPaid,
  isLoading,
    isPaymentPending
}: OptionsProps) => {
  return (
    <div className={styles.container}>
      <form>
        <div>{instructions}</div>

        <ButtonFooter showNote>
          <Button
            type="button"
            text={isPaymentPending ? "Awaiting Customer Confirmation" : "I have transferred"}
            buttonStyle="primary"
            onClick={onPaid}
            disabled={isPaymentPending}
            isButtonLoading={isLoading}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
